import { Component } from "@kluntje/core";
import { addClass, removeClass } from "@kluntje/js-utils/lib/dom-helpers";
import { ACTIVE } from "Helper/cssClasses";
import CookieService from "Services/CookieService";

/**
 * Custom Element to add and handle cookie layer
 */
class FRACookieLayer extends Component {
  constructor() {
    super({
      ui: {
        closeBtn: ".fra-js-cookie-layer__close :-one",
      },
      events: [
        {
          event: "click",
          target: "closeBtn",
          handler: "handleCTAClick",
        },
      ],
    });
  }

  /**
   * @override
   */
  connectedCallback() {
    super.connectedCallback();
    if (CookieService.cookiesAccepted) return;
    addClass(this, ACTIVE);
  }

  /**
   * handles CTA click, by setting cookie and removing itself
   * @param { MouseEvent | TouchEvent } e
   */
  handleCTAClick(e: MouseEvent | TouchEvent): void {
    e.preventDefault();
    removeClass(this, ACTIVE);
    CookieService.allowCookies();
  }
}

customElements.define("fra-m-cookie-layer", FRACookieLayer);

export default FRACookieLayer;
